import styled from 'styled-components'

interface FooterProps {
  children: any
  background?: 'gradient' | 'fill'
}

// button size large일 때 Footer 최소 높이
export const FOOTER_MIN_HEIGHT = 72

export function Footer({ background = 'gradient', children }: FooterProps) {
  return <Container background={background}>{children}</Container>
}

const Container = styled.div<{ background: FooterProps['background'] }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  opacity: 1 !important;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 500px;
  min-height: ${FOOTER_MIN_HEIGHT}px;
  padding: 16px 16px calc(env(safe-area-inset-bottom) + 8px)};
  background: ${({ background }) =>
    background === 'gradient'
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 25.63%)'
      : '#ffffff'} !important;
`
